import { Form, Space } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { AddButton, Button } from 'components/atoms/button';
import { Drawer } from 'components/atoms/drawer';
import { ColorPicker } from 'components/molecules/color-picker/color-picker';
import { toastService } from 'components/molecules/toast';
import { Appearance } from 'components/organisms/module-settings/preferences/appearance-settings/appearance';
import {
  CustomerLayout,
  VendorLayout,
} from 'components/organisms/module-settings/preferences/appearance-settings/layout';
import { getTheme } from 'components/organisms/module-settings/preferences/appearance-settings/util';
import { useAccount } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
import { useAccountUpdateMutation } from 'queries';

export const AppearanceSettingsDrawer = ({ visible, onClose }) => {
  const {
    company: { companyName },
    metaData,
  } = useAccount();
  const [form] = Form.useForm();
  const { mutate, isLoading } = useAccountUpdateMutation();
  const initialValues = getTheme(metaData?.theme);

  const service = toastService({
    title: useTranslation('settings.organisation.appearance.success.title'),
    message: useTranslation('settings.organisation.appearance.success.message'),
  });

  const [formData, setFormData] = useState(initialValues);
  const submitForm = async () => {
    const values = await form.validateFields();
    const theme = getTheme(values);

    mutate(
      { metaData: { theme } },
      {
        onSuccess: () => {
          service.success();
          onClose();
        },
      },
    );
  };
  const handleValuesChange = (values, allValues) => {
    setFormData(getTheme(allValues));
  };

  return (
    <Drawer
      title={<FormattedMessage id="settings.organisation.appearance" />}
      width={688}
      visible={visible}
      onClose={onClose}
      footer={
        <>
          <Button disabled={isLoading} onClick={onClose}>
            <FormattedMessage id="cancel" />
          </Button>
          <AddButton loading={isLoading} onClick={submitForm}>
            <FormattedMessage id="save" />
          </AddButton>
        </>
      }
    >
      <Space size={24} direction="vertical">
        <Space size={24}>
          <Appearance
            title={
              <FormattedMessage
                id="settings.organisation.appearance.company"
                values={{ companyName }}
              />
            }
            icon={
              <VendorLayout
                brandColor={formData.brandColor}
                sideNavBg={formData.sideNavBg}
                sideNavText={formData.sideNavText}
              />
            }
          />
          <Appearance
            title={
              <FormattedMessage id="settings.organisation.appearance.customer" />
            }
            icon={
              <CustomerLayout
                brandColor={formData.brandColor}
                sideNavBg={formData.sideNavBg}
                sideNavText={formData.sideNavText}
              />
            }
          />
        </Space>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          onValuesChange={handleValuesChange}
        >
          <Form.Item name={['brandColor']}>
            <ColorPicker />
          </Form.Item>
          <Form.Item name={['sideNavBg']}>
            <ColorPicker />
          </Form.Item>
        </Form>
      </Space>
    </Drawer>
  );
};
